module.exports = __webpack_public_path__ + "static/media/invoices-mob-icon.f6770815.svg";